(function (global) {
  'use strict';
  var ROOT = '[data-dellamoda-size-picker]';
  var GROUP = '[data-dellamoda-size-option]';
  var SINGLE = '[data-dellamoda-mto-single]';
  var NATIVE_TIMING = '.ot-estimated-shipping, .restock-rocket-preorder-description, .product__cro-lead';
  var SUPPRESSED = 'data-mto-native-timing-suppressed';

  function includesId(values, id) {
    return Array.isArray(values) && values.some(function (value) { return String(value) === String(id); });
  }

  function parseDeliveryConfig(value) {
     if (!value) return null;
     if (typeof value === 'string') {
       try { value = JSON.parse(value); } catch (_) { return null; }
     }
     return value && typeof value === 'object' ? value : null;
   }

   function zonedToday(timeZone, now) {
     var instant = now instanceof Date ? now : new Date(now || Date.now());
     try {
       var parts = new Intl.DateTimeFormat('en-US', {
         timeZone: timeZone,
         year: 'numeric',
         month: '2-digit',
         day: '2-digit'
       }).formatToParts(instant);
       var values = {};
       parts.forEach(function (part) { values[part.type] = part.value; });
       return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
     } catch (_) {
       return new Date(Date.UTC(instant.getUTCFullYear(), instant.getUTCMonth(), instant.getUTCDate()));
     }
   }

   function addCalendarDays(date, days) {
     return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() + days));
   }

   function formatDate(date, locale) {
     return new Intl.DateTimeFormat(locale || 'en-US', {
       timeZone: 'UTC',
       year: 'numeric',
       month: 'short',
       day: 'numeric'
     }).format(date);
   }

   function formatDateRange(start, end, locale) {
     return formatDate(start, locale) + '–' + formatDate(end, locale);
   }

   function deliveryDetail(data, now) {
     if (!data || data.coveredBrand !== true) return data && data.productionDetail || '';
     if (data.mtoRuleStatus !== 'valid') return 'Made to order · Delivery timing needs confirmation';

     var config = parseDeliveryConfig(data.deliveryConfig);
     var rule = config && config.rules && config.rules[data.mtoRuleKey];
     var minDays = rule && Number(rule.minDays);
     var maxDays = rule && Number(rule.maxDays);
     if (!config || config.basis !== 'calendar_days_from_order_date' ||
         !Number.isInteger(minDays) || !Number.isInteger(maxDays) ||
         minDays < 0 || maxDays < minDays) {
       return 'Made to order · Delivery timing needs confirmation';
     }

     var locale = global.document && global.document.documentElement.lang || 'en-US';
     var today = zonedToday(config.timezone || 'America/Los_Angeles', now);
     var range = formatDateRange(addCalendarDays(today, minDays), addCalendarDays(today, maxDays), locale);
     return 'Made to order · Order today for estimated delivery ' + range;
   }


  function eligiblePlan(variant, config, isB2B) {
    if (!config || !config.settings || config.settings.enable_app !== true || !Array.isArray(config.sellingPlans)) return null;
    if (Number((config.variantsPreorderMaxCount || {})[variant.id]) > 0 || Number((config.variantsPreorderMaxCountForMarket || {})[variant.id]) > 0) return null;
    return config.sellingPlans.find(function (plan) {
      if (!plan || plan.enabled !== true || !includesId(plan.variant_ids, variant.id)) return false;
      if (includesId(config.disabledSellingPlanIds, plan.shopify_selling_plan_id)) return false;
      if (isB2B && plan.b2b_enabled !== true) return false;
      if (plan.batches_enabled || plan.preorder_min_quantity || plan.preorder_max_quantity) return false;
      if (plan.markets_enabled && !includesId(plan.shopify_market_ids, config.marketId)) return false;
      if (plan.schedule_offer) {
        var start = Date.parse(plan.schedule_start_date);
        var end = Date.parse(plan.schedule_end_date);
        if (!Number.isFinite(start) || Date.now() < start || (Number.isFinite(end) && Date.now() >= end)) return false;
      }
      var wording = [plan.preorder_button_text, plan.preorder_badge_enabled ? plan.preorder_badge_text : ''].join(' ');
      return /made[ -]to[ -]order/i.test(wording);
    }) || null;
  }

  function classify(variant, data, config) {
    if (!variant || variant.available !== true) return { state: 'unavailable', detail: '' };
    var tracked = !!variant.inventory_management;
    if (tracked && Number(variant.inventory_quantity) <= 0 && variant.inventory_policy === 'deny') return { state: 'unavailable', detail: '' };
    if (tracked && Number(variant.inventory_quantity) > 0) return { state: 'in_stock', detail: '' };
    if (data.madeToOrder) return { state: 'made_to_order', detail: data.coveredBrand ? deliveryDetail(data) : data.productionDetail || '' };
    if (tracked && variant.inventory_policy === 'continue') {
      var plan = eligiblePlan(variant, config, data.isB2B);
      if (plan) {
        return { state: 'made_to_order', detail: data.coveredBrand ? deliveryDetail(data) : '' };
      }
      return { state: 'available_to_order', detail: '' };
    }
    return { state: 'available', detail: '' };
  }

  function readOptions(root, data) {
    return data.variants[0].options.map(function (_, index) {
      var select = root.querySelector('select[data-index="option' + (index + 1) + '"]');
      return select ? select.value : '';
    });
  }

  function findVariant(data, options) {
    return data.variants.find(function (variant) {
      return variant.options.every(function (value, index) { return value === options[index]; });
    }) || null;
  }

  function writeText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function productScope(root) {
    return root.closest('[data-section-type="product"]') || root.closest('.shopify-section') || root.parentElement;
  }

  function isConflictingTimingText(value) {
    return /\b(production|delivery|shipping|ships?|arrives?|weeks?)\b/i.test(value || '');
  }

  function nativeTimingScopes(root, data) {
    var scopes = [];
    var scope = productScope(root);
    if (scope) scopes.push(scope);
    var config = global._StoqConfig || global._RestockRocketConfig;
    var appProduct = config && config.product;
    if (global.document && appProduct && String(appProduct.id) === String(data.productId) && scopes.indexOf(global.document) === -1) {
      scopes.push(global.document);
    }
    return scopes;
  }

  function syncNativeTiming(root, data, suppress) {
    if (!global.document || !data) return;
    var productId = String(data.productId);
    global.document.querySelectorAll('[' + SUPPRESSED + ']').forEach(function (element) {
      if (element.getAttribute(SUPPRESSED) === productId) element.removeAttribute(SUPPRESSED);
    });
    if (!suppress || data.coveredBrand !== true) return;
    nativeTimingScopes(root, data).forEach(function (scope) {
      scope.querySelectorAll('.ot-estimated-shipping').forEach(function (element) {
        element.setAttribute(SUPPRESSED, productId);
      });
      scope.querySelectorAll('.product__cro-lead').forEach(function (element) {
        element.setAttribute(SUPPRESSED, productId);
      });
      scope.querySelectorAll('.restock-rocket-preorder-description .preorder-detail-text').forEach(function (text) {
        if (!isConflictingTimingText(text.textContent)) return;
        (text.closest('.preorder-detail-item') || text).setAttribute(SUPPRESSED, productId);
      });
    });
  }

  function render(root) {
    var data = root.dellamodaSizeData;
    if (!data || !data.variants.length) return;
    var options = readOptions(root, data);
    var config = global._StoqConfig || global._RestockRocketConfig;
    var selectedVariant = findVariant(data, options);
    var selectedState = classify(selectedVariant, data, config);
    root.querySelectorAll(GROUP).forEach(function (group) {
      var index = Number(group.getAttribute('data-dellamoda-size-option'));
      var feedback = group.querySelector('[data-dellamoda-size-feedback]');
      var status = group.querySelector('[data-dellamoda-size-status]');
      var detail = group.querySelector('[data-dellamoda-size-detail]');
      var legend = group.querySelector('[data-dellamoda-size-legend]');
      var hasStock = false;
      var hasMto = false;
      var hasOtherAvailable = false;
      var hasUnavailable = false;
      var buttons = group.querySelectorAll('button.product__chip[data-option-value]');
      buttons.forEach(function (button) {
        var combination = options.slice();
        combination[index] = button.getAttribute('data-option-value');
        var result = classify(findVariant(data, combination), data, config);
        hasStock = hasStock || result.state === 'in_stock';
        hasMto = hasMto || result.state === 'made_to_order';
        hasOtherAvailable = hasOtherAvailable || result.state === 'available' || result.state === 'available_to_order';
        hasUnavailable = hasUnavailable || result.state === 'unavailable';
        var state = result.state;
        if (button.getAttribute('data-dellamoda-stock-state') !== state) button.setAttribute('data-dellamoda-stock-state', state);
        var selected = button.classList.contains('selected');
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', combination[index] + ' · ' + data.labels[state]);
        var dot = button.querySelector('.dellamoda-stock-dot');
        if (state === 'in_stock' && !dot) {
          dot = global.document.createElement('span');
          dot.className = 'dellamoda-stock-dot';
          dot.setAttribute('aria-hidden', 'true');
          button.appendChild(dot);
        } else if (state !== 'in_stock' && dot) { dot.remove(); }
      });
      if (!feedback || !status || !detail || !legend) return;
      feedback.hidden = false;
      var legendKey = [hasStock, hasMto, hasOtherAvailable, hasUnavailable].join('|');
      if (legend.dataset.state !== legendKey) {
        legend.dataset.state = legendKey;
        legend.replaceChildren();
        if (hasStock) {
          var stockDot = global.document.createElement('span');
          stockDot.className = 'dellamoda-stock-dot';
          stockDot.setAttribute('aria-hidden', 'true');
          legend.appendChild(stockDot);
          legend.appendChild(global.document.createTextNode(data.labels.stock_legend));
        }
        var extras = [];
        if (hasMto && !hasOtherAvailable) extras.push(data.labels.mto_legend);
        if (hasUnavailable) extras.push(data.labels.unavailable_legend);
        if (extras.length) {
          var extra = global.document.createElement('span');
          extra.setAttribute('data-dellamoda-legend-extra', '');
          extra.textContent = extras.join(' · ');
          legend.appendChild(extra);
        }
        legend.hidden = !hasStock && !extras.length;
      }
      var pending = group.hasAttribute('data-cro-require-pick') && group.getAttribute('data-cro-picked') !== '1' && group.getAttribute('data-dellamoda-size-picked') !== 'true';
      if (pending) {
        writeText(status, data.labels.select_size);
        detail.hidden = true;
        writeText(detail, '');
      } else {
        writeText(status, options[index] + ' · ' + data.labels[selectedState.state]);
        writeText(detail, selectedState.detail);
        detail.hidden = !selectedState.detail;
      }
    });
    syncNativeTiming(root, data, selectedState.state === 'made_to_order');
  }

  function initialize(root) {
    if (root.dellamodaSizeData) return;
    var json = root.querySelector('[data-dellamoda-size-data]');
    try { root.dellamodaSizeData = JSON.parse(json.textContent); } catch (_) { return; }
    var pending = false;
    function schedule() {
      if (pending) return;
      pending = true;
      global.setTimeout(function () { pending = false; render(root); }, 0);
    }
    function onChange(event) {
      var group = event.target.closest && event.target.closest(GROUP);
      if (group && event.isTrusted && event.target.matches('select[data-index]')) group.setAttribute('data-dellamoda-size-picked', 'true');
      schedule();
    }
    function onClick(event) {
      var button = event.target.closest && event.target.closest('button[data-option-value]');
      var group = button && button.closest(GROUP);
      if (group && root.contains(group)) group.setAttribute('data-dellamoda-size-picked', 'true');
      schedule();
    }
    root.addEventListener('change', onChange, true);
    root.addEventListener('click', onClick);
    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.type === 'attributes' || (record.type === 'childList' && record.target.matches('button.product__chip'));
      })) schedule();
    });
    observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-cro-picked'] });
    var deliveryDateTimer = global.setInterval(schedule, 60000);
    root.dellamodaSizeDestroy = function () {
      global.clearInterval(deliveryDateTimer);
      observer.disconnect();
      root.removeEventListener('change', onChange, true);
      root.removeEventListener('click', onClick);
      syncNativeTiming(root, root.dellamodaSizeData, false);
      delete root.dellamodaSizeData;
    };
    render(root);
    [150, 800, 2000, 5000].forEach(function (delay) { global.setTimeout(function () { if (root.isConnected) render(root); }, delay); });
  }

  function renderSingle(root) {
    var data = root.dellamodaSingleData;
    var status = root.querySelector('[data-dellamoda-mto-single-status]');
    var scope = productScope(root);
    var picker = scope && scope.querySelector(ROOT);
    var pickerHasSizeFeedback = picker && picker.querySelector(GROUP + ' [data-dellamoda-size-feedback]');
    if (!data || !status || !scope || pickerHasSizeFeedback || data.coveredBrand !== true || !data.variants.length) {
      root.hidden = true;
      return;
    }
    var variantInput = scope.querySelector('[data-product-form] [name="id"]');
    var selectedVariant = data.variants.find(function (variant) {
      return variantInput && String(variant.id) === String(variantInput.value);
    }) || data.variants[0];
    var result = classify(selectedVariant, data, global._StoqConfig || global._RestockRocketConfig);
    var visible = result.state === 'made_to_order';
    writeText(status, visible ? result.detail : '');
    root.hidden = !visible;
    syncNativeTiming(root, data, visible);
  }

  function initializeSingle(root) {
    if (root.dellamodaSingleData) return;
    var json = root.querySelector('[data-dellamoda-size-data]');
    try { root.dellamodaSingleData = JSON.parse(json.textContent); } catch (_) { return; }
    var scope = productScope(root);
    function schedule() { renderSingle(root); }
    if (scope) scope.addEventListener('change', schedule, true);
    var timer = global.setInterval(schedule, 60000);
    root.dellamodaSingleDestroy = function () {
      global.clearInterval(timer);
      if (scope) scope.removeEventListener('change', schedule, true);
      syncNativeTiming(root, root.dellamodaSingleData, false);
      delete root.dellamodaSingleData;
    };
    renderSingle(root);
    [150, 800, 2000, 5000].forEach(function (delay) { global.setTimeout(function () { if (root.isConnected) renderSingle(root); }, delay); });
  }

  function initializeAll(scope) {
    scope.querySelectorAll(ROOT).forEach(initialize);
    if (scope.matches && scope.matches(ROOT)) initialize(scope);
    scope.querySelectorAll(SINGLE).forEach(initializeSingle);
    if (scope.matches && scope.matches(SINGLE)) initializeSingle(scope);
  }

  var api = {
    addCalendarDays: addCalendarDays,
    classify: classify,
    deliveryDetail: deliveryDetail,
    eligiblePlan: eligiblePlan,
    findVariant: findVariant,
    formatDateRange: formatDateRange,
    initializeAll: initializeAll,
    isConflictingTimingText: isConflictingTimingText,
    render: render,
    zonedToday: zonedToday
  };
  global.DellamodaSizePicker = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!global.document) return;
  function start() {
    var style = global.document.createElement('style');
    style.setAttribute('data-mto-native-timing-style', '');
    style.textContent = '[' + SUPPRESSED + '] { display: none !important; }';
    global.document.head.appendChild(style);
    initializeAll(global.document);
    new MutationObserver(function (records) {
      var refreshTiming = false;
      records.forEach(function (record) {
        var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target && (target.matches(NATIVE_TIMING) || target.closest(NATIVE_TIMING))) refreshTiming = true;
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.matches(ROOT) || node.querySelector(ROOT) || node.matches(SINGLE) || node.querySelector(SINGLE))) initializeAll(node);
          if (node.nodeType === 1 && (node.matches(NATIVE_TIMING) || node.querySelector(NATIVE_TIMING))) refreshTiming = true;
        });
        record.removedNodes.forEach(function (node) {
          if (node.nodeType !== 1 || node.isConnected) return;
          var roots = Array.from(node.querySelectorAll(ROOT));
          if (node.matches(ROOT)) roots.push(node);
          roots.forEach(function (root) { if (root.dellamodaSizeDestroy) root.dellamodaSizeDestroy(); });
          var singles = Array.from(node.querySelectorAll(SINGLE));
          if (node.matches(SINGLE)) singles.push(node);
          singles.forEach(function (root) { if (root.dellamodaSingleDestroy) root.dellamodaSingleDestroy(); });
        });
      });
      if (refreshTiming) {
        global.document.querySelectorAll(ROOT).forEach(render);
        global.document.querySelectorAll(SINGLE).forEach(renderSingle);
      }
    }).observe(global.document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style'] });
  }
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', start);
  else start();
  global.addEventListener('stoq:loaded', function () {
    global.document.querySelectorAll(ROOT).forEach(render);
    global.document.querySelectorAll(SINGLE).forEach(renderSingle);
  });
  global.addEventListener('pageshow', function () {
    global.document.querySelectorAll(ROOT).forEach(render);
    global.document.querySelectorAll(SINGLE).forEach(renderSingle);
  });
}(typeof window !== 'undefined' ? window : globalThis));
